import { useCallback, useTransition } from 'react'

import { useNavigate } from '@tanstack/react-router'

import type { LinkOptions } from '@tanstack/react-router'

export type UpdateURLOptions = {
	to?: LinkOptions['to']
	search: LinkOptions['search']
}

/**
 * Custom Hook to update Search URL with search state using transition to avoid blocking UI updates
 */
export const useUpdateURL = () => {
	const navigate = useNavigate()

	const [_isPending, startTransition] = useTransition()

	const updateURL = useCallback(
		({ to = '.', search }: UpdateURLOptions) => {
			// Use startTransition to avoid blocking UI updates
			startTransition(() => {
				navigate({
					to,
					// Merge the new state with the existing URL search params
					search: (prev) => ({
						...prev,
						...(search as unknown as Record<string, unknown>),
					}),
				})
			})
		},
		[navigate],
	)

	return { updateURL }
}
